<template>
    <div class="pa-4 grey lighten-5">
    <v-stepper 
        alt-labels
        non-linear
        v-model="getCurrentStep"
    >
        <v-stepper-header>
            <template v-for="step in steps">
                <v-stepper-step
                    :key="`${step.number}-step`"                    
                    :complete="formProgress[step.model]"
                    :step="step.number"
                    @click="displaySection(step.route, step.number)"
                    :color="themeColor"
                >
                    {{ step.label }}
                </v-stepper-step>

                <v-divider
                    v-if="step.number !== numberOfSteps"
                    :key="step.number"
                ></v-divider>                 

            </template>
        </v-stepper-header>
    </v-stepper>
   </div> 
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'FormProgress',
    data: () => ({
        steps: [
            {label: 'Student Data', number: 1, model: 'studentData', route: '/registration/student-data'},
            {label: 'Family Data', number: 2, model: 'familyData', route: '/registration/family-data'},
            {label: 'Health Data', number: 3, model: 'healthData', route: '/registration/health-data'},
            {label: 'Other Data', number: 4, model: 'otherData', route: '/registration/other-data'},
            {label: 'Documents', number: 5, model: 'documents', route: '/registration/documents'},
            {label: 'Submit', number: 6, model: 'submit', route: '/registration/complete'},           
        ],        
    }),    
    computed: {
        numberOfSteps: function () {
            return this.steps.length;
        },
        ...mapGetters({
            getCurrentStep: 'form/getCurrentStep',
            formProgress: 'form/getFormProgress',
            primaryColor: 'form/getPrimaryColor',
            colorDarken: 'form/getColorDarken',
        }),
         themeColor(){          
          return this.primaryColor + ' ' + this.colorDarken;
      },
    },
    methods: {
        ...mapMutations({
            setCurrentStep: 'form/setCurrentStep'
        }),
        displaySection(route, step){
            ///console.log(route);
            this.setCurrentStep(step);
            this.$router.push(route);            
            //console.log(this.currentStep);
        }
    }
}
</script>